<template>
<div class="animated fadeIn">
  <div class="card dash-field">
    <div class="row m-0">
      <div class="card-body col-md-8">
        <h3>Manage chapters</h3>
      </div>
      <div class="col-md-4 m-auto">
        <button type="button" class="btn btn-add" @click="showModal()">
          <!-- icon icon="plus"></icon --> {{$t('ADDNEWCHAPTER')}}
        </button>
      </div>
    </div>
  </div>
  <div class="card">
    <div class="card-body">
      <div class="row mb-2">
        <div class="col-sm-6">
          <b-form inline>
            <label class="mr-sm-2 d-inline">{{$t('ITEMSPERPAGE')}}</label>
            <b-form-select v-model="pagination.limit" :options="[{value: 25, text: '25'},{value: 50, text: '50'},{value: 100, text: '100'}]"></b-form-select>
          </b-form>
        </div>
        <div class="col-sm-6">
          <b-form-input class="col-sm-3 float-right" v-model="pagination.query" :placeholder="$t('SEARCH')"></b-form-input>
        </div>
      </div>
      <div class="clear20">&nbsp;</div>
      <div class="row mb-2">
        <div class="col-sm-12">
          <table class="table table-foursight table-striped table-hover table-sm">
            <thead>
              <tr>
                <th>{{$t('TITLE')}}</th>
                <th>{{$t('LINKEDQUIZ')}}</th>
                <th>{{$t('TRAININGBLOCK')}}</th>
                <th>{{$t('PREVIEW')}}</th>
                <th>{{$t('FILE')}}</th>
                <th>{{$t('ACTION')}}</th>
              </tr>
            </thead>
            <draggable v-model="response.root" @start="drag=true" @end="drag=false" @change="changeOrder" tag="tbody">
              <template v-for="item in response.root">
                <tr class=" table-ellipsis" :key="item.chapterId">
                  <td v-html="item.title"></td>
                  <td>{{item.quizName}}</td>
                  <td>{{item.trainingBlockName}}</td>
                  <td>
                    <button type="button" class="btn btn-quaternary btn-sm" @click="previewChapters(item)">{{$t('PREVIEWCHAPTERS')}}</button>
                  </td>
                  <td>
                    <button type="button" class="btn btn-primary btn-sm" @click="showTrainingPage(item.chapterId)">{{$t('VIEWPAGES')}}</button>
                  </td>
                  <td>
                    <button type="button" class="btn btn-secondary btn-sm mr-2" @click="showModal(item)">{{$t('EDIT')}}</button>
                    <button type="button" class="btn btn-delete btn-sm" @click="deleteRow(item.chapterId)">{{$t('DELETE')}}</button>
                  </td>
                </tr>
              </template>
            </draggable>
          </table>
          <nav>
            <b-pagination align="center" :total-rows="parseInt(response.totalCount)" v-model="pagination.currentPage" :per-page="pagination.limit"></b-pagination>
          </nav>
        </div>
      </div>
    </div>
  </div>
  <b-modal ref="formmodal" :title="$t('TRAININGCHAPTERSFORM')" ok-title="submit" hide-footer size='lg' no-close-on-backdrop>
    <div class="d-block">
      <trainingchaptersform v-bind:formData="formData" v-bind:formError="formError" v-bind:quiz="quiz" v-bind:trainingBlock="trainingBlock"></trainingchaptersform>
    </div>
    <div class="text-right">
      <b-btn class="mt-3" variant="secondary-trans mr-4" @click="hideModal">{{$t('CANCEL')}}</b-btn>
      <b-btn class="mt-3" variant="primary" @click="submitData(formData)">{{$t('SAVE')}}</b-btn>
    </div>
  </b-modal>
  <b-modal ref="formpreviewmodal" :title="$t('PREVIEWCHAPTERS')" ok-title="submit" hide-footer size='xl' centered no-close-on-backdrop>
    <div class="d-block">
      <formpreview v-bind:chapterContent="chapterContent" v-bind:traingnPage="trainingPage" v-bind:showReview="showReview" v-bind:previousPage="previousPage" v-bind:nextPage="nextPage" v-bind:backToChap="backToChap"></formpreview>
    </div>
    <div class="text-right">
      <b-btn class="mt-3" variant="primary mr-lg" @click="openChapterPages" v-if="showReview">{{$t('REVIEWCHAPTES')}}</b-btn>
      <b-btn class="mt-3" variant="secondary-trans mr-4" @click="openPreviousPage" v-if="previousPage">{{$t('PREVIOUSPAGE')}}</b-btn>
      <b-btn class="mt-3" variant="primary mr-lg" @click="openNextPage" v-if="nextPage">{{$t('NEXTPAGE')}}</b-btn>
      <b-btn class="mt-3" variant="primary mr-lg" @click="hidePreviewModal" v-if="backToChap">{{$t('BACKTOCHAPTER')}}</b-btn>
    </div>
  </b-modal>
</div>
</template>

<script>
import
{
  mapActions,
  mapGetters
}
from 'vuex'
import Api from '@/api/training/TrainingChapters'
import TrainingPagesApi from '@/api/training/TrainingPages'
import QuizApi from '@/api/training/Quiz'
import TrainingBlockApi from '@/api/training/TrainingBlock'


import TrainingChaptersForm from './Form'
import FormPreview from './FormPreview'

export default
{
  name: 'TrainingChapters',
  components:
  {
    trainingchaptersform: TrainingChaptersForm,
    formpreview: FormPreview
  },
  data: function()
  {
    return {
      response:
      {},
      formError:
      {},
      quiz:
      {},
      trainingBlock: {},
      chapterContent:
      {},
      trainingPage:
      {},
      showReview: true,
      previousPage: false,
      nextPage: false,
      backToChap: false,
      formData:
      {
        title: '',
        content: '',
        isAdvance: 0,
      },
      pagination:
      {
        query: '',
        currentPage: 1,
        limit: 25,
        searchTimeout: false
      },
      paginationPages:
      {
        query: '',
        currentPage: 1,
        limit: 1,
        searchTimeout: false
      }
    }
  },
  created()
  {
    var me = this;
    me.getData();
    me.getQuiz();
    me.getTrainingBlock();
  },
  methods:
  {
    async changeOrder(item)
    {
      var me = this;
      try
      {
        var moved = item.moved;

        var movedData = moved.element;
        var oldData = me.response.root[moved.newIndex + 1];

        var finalNum = parseInt(oldData.orderNum) - 1;

        var data = await Api.updateOrderNum(
        {
          id: movedData.chapterId,
          finalNum: finalNum
        });
        me.$notify.notice(data);
        await me.getData();
      }
      catch (e)
      {
        me.$notify.notice(e);
      }
    },
    showTrainingPage(id)
    {
      var me = this;
      me.$router.push(
      {
        path: `/training/trainingchapters/trainingpages/${id}`
      });
    },
    async getData()
    {
      var me = this;
      try
      {
        var data = await Api.selectRow(me.getParams);
        if (data.error && data.error == true)
        {
          me.$notify.notice(data);
          me.loading = false;
          return;
        }

        me.response = data;
      }
      catch (e)
      {
        me.$notify.notice(e);
      }
    },
    async getQuiz()
    {
      var me = this;
      try
      {
        var data = await QuizApi.selectRow();
        if (data.error && data.error == true)
        {
          me.$notify.notice(data);
          me.loading = false;
          return;
        }

        me.quiz = data;
      }
      catch (e)
      {
        me.$notify.notice(e);
      }
    },
    async getTrainingBlock()
    {
      var me = this;
      try
      {
        var data = await TrainingBlockApi.selectRow();
        if (data.error && data.error == true)
        {
          me.$notify.notice(data);
          me.loading = false;
          return;
        }

        me.trainingBlock = data;
      }
      catch (e)
      {
        me.$notify.notice(e);
      }
    },
    async deleteRow(id)
    {
      var me = this;
      try
      {
        me.$store.commit('setModalAlert',
        {
          text: me.$i18n.t('AREYOUSHURE'),
          btnAction: async function()
          {
            var data = await Api.deleteRow(
            {
              id: id
            });
            me.$notify.notice(data);
            await me.getData();
          }
        })
      }
      catch (e)
      {
        me.$notify.notice(e);
      }
    },
    showModal(item)
    {
      var me = this;
      if (typeof item != 'undefined') me.formData = item;
      this.$refs.formmodal.show()
    },
    async submitData(item)
    {
      var me = this;
      try
      {
        if (typeof item.chapterId != 'undefined')
        {
          item.id = item.chapterId;
          delete(item.chapterId);
        }

        var data = await Api.submitData(item);
        if (data.error)
        {
          me.$notify.notice(data);
          me.formError = data;
        }
        else
        {
          me.$notify.notice(data);
          me.hideModal();
          await me.getData();
        }
      }
      catch (e)
      {
        me.$notify.notice(e);
      }
    },
    hideModal()
    {
      var me = this;
      this.$refs.formmodal.hide();

      me.formData = {
        title: '',
        content: ''
      };

      me.formError = {};
    },
    hidePreviewModal()
    {
      var me = this;
      me.$refs.formpreviewmodal.hide();
      me.paginationPages.currentPage = 1;
    },
    previewChapters(item)
    {
      var me = this;
      me.$refs.formpreviewmodal.show();

      me.$set(me.paginationPages, 'chapterId', item.chapterId);

      me.chapterContent = item;

      me.showReview = true;
      me.previousPage = false;
      me.nextPage = false;
      me.backToChap = false;
    },
    async openChapterPages()
    {
      var me = this;
      try
      {
        var data = await TrainingPagesApi.selectRow(me.getParamsPages);
      }
      catch (e)
      {
        me.$notify.notice(e);
      }

      if (data.root.length != 0)
      {
        me.trainingPage = data;

        me.showReview = false;
        me.previousPage = (me.getParamsPages.currentPage == 1) ? false : true;
        me.nextPage = ((me.getParamsPages.limit + me.getParamsPages.start) == me.trainingPage.totalCount) ? false : true;
        me.backToChap = ((me.getParamsPages.limit + me.getParamsPages.start) == me.trainingPage.totalCount) ? true : false;
      }
      else
      {
        me.showReview = false;
        me.backToChap = true;
      }
    },
    openPreviousPage()
    {
      var me = this;
      me.paginationPages.currentPage -= 1;
      me.openChapterPages();
    },
    openNextPage()
    {
      var me = this;
      me.paginationPages.currentPage += 1;
      me.openChapterPages();
    }
  },
  watch:
  {
    'pagination.limit': function(val)
    {
      var me = this;
      me.getData();
    },
    'pagination.currentPage': function(val)
    {
      var me = this;
      me.getData();
    },
    'pagination.query': function(val)
    {
      var me = this;

      if (me.pagination.searchTimeout != false) clearTimeout(me.pagination.searchTimeout);

      me.pagination.searchTimeout = setTimeout(function()
      {
        me.getData();
        me.pagination.searchTimeout = false;
      }, 300);
    }
  },
  computed:
  {
    getParams: function()
    {
      var me = this;
      var data = Object.assign(
      {}, me.pagination,
      {});
      data.start = (data.currentPage - 1) * data.limit;
      return data;
    },
    getParamsPages: function()
    {
      var me = this;
      var data = Object.assign(
      {}, me.paginationPages,
      {});
      data.start = (data.currentPage - 1) * data.limit;
      return data;
    }
  }
}
</script>
